import {
  Checkbox,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { HomeWidgetType } from '../../settings/validation/HomeWidget';

import { WidgetOption } from './hooks/useHomePageContextMenu';

export interface HomePageContextMenuProps {
  anchorPosition: { top: number; left: number } | null;
  open: boolean;
  onClose: () => void;
  onWidgetToggle: (widgetType: HomeWidgetType) => void;
  widgetOptions: WidgetOption[];
}

export const HomePageContextMenu: React.FC<HomePageContextMenuProps> = ({
  anchorPosition,
  open,
  onClose,
  onWidgetToggle,
  widgetOptions,
}) => {
  const { t } = useTranslation();

  const handleMenuItemClick = (widgetType: HomeWidgetType) => {
    onWidgetToggle(widgetType);
  };

  return (
    <Menu
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition || undefined}
      open={open}
      onClose={onClose}
    >
      {widgetOptions.map((option) => (
        <MenuItem
          key={option.id}
          onClick={() => handleMenuItemClick(option.id)}
          dense
        >
          <ListItemIcon>
            <Checkbox checked={option.enabled} />
          </ListItemIcon>
          <ListItemText primary={t(option.labelKey)} />
        </MenuItem>
      ))}
    </Menu>
  );
};
